import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import closeDarkImg from "@front-shared/assets/images/icons/close-dark.svg"

export const CsvReviewPageHeaderComponent: React.FunctionComponent<
    ICsvReviewPageHeaderComponentProps
> = props => {
    return (
        <div
            className={`relative py-[12px] mb-[24px] ${props.className ?? ""}`}
            style={props.style}
        >
            <div className="flex flex-wrap gap-2 w-full">
                <PrimaryText
                    className="mr-[16px] shrink-0 whitespace-nowrap"
                    size={29}
                    lineHeight={35}
                    weight="semibold"
                >
                    {props.title}
                </PrimaryText>

                <div
                    className="
                        px-[8px] py-[2px]
                        flex items-center
                        rounded-[4px] bg-white
                        flex-1 min-w-[300px] max-w-fit
                    "
                >
                    <PrimaryText
                        typography="h6"
                        className="mr-[4px] whitespace-nowrap overflow-hidden text-ellipsis"
                        title={props.filename}
                    >
                        {props.filename}
                    </PrimaryText>

                    <button
                        type="button"
                        onClick={props.onClose}
                        className="p-[4px] border-0 bg-transparent cursor-pointer"
                    >
                        <img src={closeDarkImg} alt="Close" />
                    </button>
                </div>
            </div>
        </div>
    )
}

interface ICsvReviewPageHeaderComponentProps {
    title: string
    filename: string
    onClose: () => void
    className?: string
    style?: React.CSSProperties
}
